module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/stats_summarized-3a1497367d6154127b90156bf8124e94.png";